<template>
  <f7-page class="page-buy-usdt" @page:afterin="pageMounted">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>MUA USDT</f7-nav-title>
    </f7-navbar>
    <f7-list inset media-list class="mt-1 mb-1">
      <f7-list-item :title="user_info.wallet_balance | numeral('0,0[.]00')" :text="`Số dư USDT (~${balance_vnd}₫)`">
        <img src="../assets/images/no-avatar.png" slot="media" class="friend-avatar">
      </f7-list-item>
    </f7-list>
    <f7-block strong inset class="alert-notice mb-0" v-if="announcements.length > 1">
      <span v-html="announcements[1].content"></span>
    </f7-block>
  </f7-page>
</template>
<style scoped>
.wallet-box {
  border        : 1px solid #000000;
  background    : rgba(0, 0, 0, 0.05);
  border-radius : 6px;
  padding       : 6px;
}
.button-otp {
  width : 110px;
}
</style>
<script>
import { mapState } from 'vuex';
import numeral from 'numeral';

export default {
  data() {
    return {
      announcements: [],
    }
  },
  computed: {
    ...mapState(['user_info', 'exchange']),
    qr_code() {
      return process.env.VUE_APP_API_URL + 'misc/generate-qrcode/' + this.user_info.wallet_address_usdt;
    },
    balance_vnd() {
      return numeral(this.user_info.wallet_balance * parseFloat(this.exchange.usdt_buy)).format('0,0')
    }
  },
  methods: {
    getAnnouncements() {
      this.$store.dispatch('getAnnouncements', {
        limit: 2
      }).then((data) => {
        this.announcements = data;
      });
    },
    pageMounted(){
      this.getAnnouncements();
    }
  }
};
</script>
